export default "__VITE_ASSET__DnkpKpQF__"